import { isValidElement, type ReactElement, type ReactNode } from 'react'

/** Visible text of rendered markdown — what sort, filter and CSV work on. */
export function nodeText(node: ReactNode): string {
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(nodeText).join('')
  if (isValidElement(node)) {
    return nodeText((node as ReactElement<{ children?: ReactNode }>).props.children)
  }
  return ''
}
